import React, { Fragment } from "react";
import "./SpotifySlider.css";

const SpotifySlider = () => {
  return (
    <Fragment>
      <section id="spotifySliderBlock">
        <article>
          <header>
            <h1>listining is Everything</h1>
          </header>
          <main>
            <p>Millions of songs and podcasts. No credit card needed.</p>
          </main>
          <footer>
            <button>Get Spotify free</button>
          </footer>
        </article>
      </section>
    </Fragment>
  );
};

export default SpotifySlider;
